import { useTransition } from "react";
import { useRecoilCallback } from "recoil";

import {
  dropdownAtomFamily,
  FORM_FIELD_KEYS,
  FORM_FIELD_TYPE_NAME_TO_RYDE_UI_UNIT,
  IDropdownItem,
  IExtendableDto,
  RydeUiUnitDropdownCacheKey,
  UPDATE_DROPDOWN_FROM_METADATA_FIELD_KEYS,
} from "@ryde/shared";

import { useDropdownSourceContext } from "../../contexts";

interface IUseSetDropdownAtomFamilyReturn {
  setDropdownAtomFamily: (
    entity: RydeUiUnitDropdownCacheKey,
    items: IDropdownItem[],
  ) => void;
  updateMetadataResolve: (metadata: IExtendableDto["metadata"]) => void;
}

export const useSetDropdownAtomFamily = (): IUseSetDropdownAtomFamilyReturn => {
  const { getDropdownItems } = useDropdownSourceContext();
  const [, startTransition] = useTransition();
  const setDropdownAtomFamily = useRecoilCallback(
    ({ set }) =>
      (entity: RydeUiUnitDropdownCacheKey, items: IDropdownItem[]) => {
        set(dropdownAtomFamily(entity), [...items]);
      },
  );

  const updateMetadataResolve = (
    metadata: IExtendableDto["metadata"],
  ): void => {
    if (!metadata) {
      return;
    }

    startTransition(() => {
      Object.keys(metadata).forEach(key => {
        if (!UPDATE_DROPDOWN_FROM_METADATA_FIELD_KEYS.has(key)) {
          return;
        }

        const entity =
          FORM_FIELD_TYPE_NAME_TO_RYDE_UI_UNIT[key as FORM_FIELD_KEYS];

        if (!entity) {
          return;
        }

        getDropdownItems(entity, true);
      });
    });
  };

  return {
    setDropdownAtomFamily,
    updateMetadataResolve,
  };
};
